import { Input } from "reactstrap";
import {
  EmployeeAdvanceStatus,
  employeeAdvanceStatusMap,
} from "features/EmployeeAdvances/constants/employee-advance.constants";

type Props = {
  status: string;
  onStatusChange: (value: string) => void;
};

export default function EmployeeAdvanceListFilters({ status, onStatusChange }: Props) {
  return (
    <div className="d-flex align-items-center gap-2">
      <Input
        type="select"
        className="form-select"
        style={{ width: 180 }}
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">All statuses</option>
        {(Object.values(EmployeeAdvanceStatus) as EmployeeAdvanceStatus[]).map((s) => (
          <option key={s} value={s}>
            {employeeAdvanceStatusMap[s]?.label ?? s}
          </option>
        ))}
      </Input>
    </div>
  );
}
